import Modal, { Styles } from "react-modal";
import { Device } from "../../coreIdAPI";

Modal.setAppElement("#root");

const customStylesDeviceDetail: Styles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "40%",
    maxHeight: "90vh",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};

export interface DeviceDetailModalProps {
  devices: Device[] | null | undefined;
  isOpen: boolean;
  onRequestClose: () => void;
}

const NOT_CAPTURED = "No capturado";

const DeviceRow = (props: { label: string; value: string }) => {
  return (
    <div
      className="flex-row"
      style={{
        justifyContent: "space-between",
        width: "100%",
        borderBottom: "0.5px solid rgba(0,0,0,0.2)",
      }}
    >
      <div className="text-normal text-medium" style={{ color: "black" }}>
        {props.label}
      </div>
      <div className="text-normal text-medium" style={{ color: "black" }}>
        {props.value}
      </div>
    </div>
  );
};

const hasNumber = (value: number | null | undefined): value is number =>
  value === 0 || !!value;

const DeviceInfo = (props: { device: Device }) => {
  const { device } = props;
  return (
    <>
      <DeviceRow label="Tipo:" value={device.type || NOT_CAPTURED} />
      <DeviceRow label="Sistema operativo:" value={device.os || NOT_CAPTURED} />
      <DeviceRow
        label="Versión del SO:"
        value={device.osVersion || NOT_CAPTURED}
      />
      <DeviceRow label="ID del dispositivo:" value={device.deviceId || NOT_CAPTURED} />
      <DeviceRow label="IP:" value={device.ip || NOT_CAPTURED} />
      <DeviceRow
        label="Núm. de CPUs:"
        value={device.numCpus || NOT_CAPTURED}
      />
      <DeviceRow
        label="Resolución de pantalla:"
        value={
          hasNumber(device.screenWidth) && hasNumber(device.screenHeigh)
            ? `${device.screenWidth} x ${device.screenHeigh}`
            : NOT_CAPTURED
        }
      />
      <DeviceRow
        label="Dispositivo confiable:"
        value={device.trusted ? "Sí" : "No"}
      />
    </>
  );
};

export const DeviceDetailModal = (props: DeviceDetailModalProps) => {
  const { devices, isOpen, onRequestClose } = props;
  const hasDevices = !!devices && devices.length > 0;

  return (
    <Modal
      isOpen={isOpen}
      style={customStylesDeviceDetail}
      onRequestClose={onRequestClose}
    >
      <div className="flex-col" style={{ justifyContent: "start" }}>
        <div
          className="text-large text-bold"
          style={{ textAlign: "center", color: "black", marginBottom: "10px" }}
        >
          Detalle de dispositivo
        </div>
        {hasDevices ? (
          devices.map((device, index) => (
            <div
              key={`${device.deviceId}-${index}`}
              className="flex-col"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {devices.length > 1 && (
                <div
                  className="text-normal text-medium text-bold"
                  style={{ color: "black", marginBottom: "4px" }}
                >
                  Dispositivo {index + 1}
                </div>
              )}
              <DeviceInfo device={device} />
            </div>
          ))
        ) : (
          <div
            className="flex-col text-normal text-medium"
            style={{
              color: "black",
              textAlign: "center",
              padding: "20px 0",
            }}
          >
            No se capturó información del dispositivo
          </div>
        )}
        <div
          className="flex-row"
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              onRequestClose();
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "20%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Cerrar
          </div>
        </div>
      </div>
    </Modal>
  );
};
